import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import { useLocation } from "react-router-dom";
import EmpoweredBundle from "../../assets/images/empowered_bundle.png";
import CheckedMark from "../../assets/images/checked_mark.png";
import "./SignupCommon.css";

declare global {
  interface Window {
    Vidalytics?: any;
  }
}

declare global {
  interface Window {
    EF?: {
      click: (params: {
        offer_id: string | null;
        affiliate_id?: string | null;
        sub1?: string | null;
        sub2?: string | null;
        sub3?: string | null;
        sub4?: string | null;
        sub5?: string | null;
        uid?: string | null;
        source_id?: string | null;
        transaction_id?: string | null;
      }) => void;
      conversion: (params: {
        offer_id: number;
        amount?: number;
        affiliate_id?: string;
      }) => void;
    };
    fbq: (...args: any[]) => void;
  }
}

const SignupPage26: React.FC = () => {
  const { setAnswer, answers } = useQuizContext();
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [err, setErr] = useState("");
  const location = useLocation();
  let { base_price_id, planType, planPrice, itemName, medicationType } =
    location.state || {}; // Ensure it doesn’t crash if state is undefined
  base_price_id = base_price_id || localStorage.getItem("priceId");
  planType = planType || localStorage.getItem("planType");
  planPrice = localStorage.getItem("planPrice");
  itemName = localStorage.getItem("itemName");
  medicationType = localStorage.getItem("medicationType");
  const navigate = useNavigate();
  const promoCode = localStorage.getItem("promoCode");
  const customer_id =  localStorage.getItem("customer_id");
  const [uuidValue, setUuidValue] = useState<string>("");
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  });
  useEffect(() => {
    setUuidValue(uuidValue);
  }, [uuidValue]);

const safeNavigate = (path: string) => {
  if (location.pathname !== path) {
    navigate(path, { replace: true });
  }
};

  // Generating the temporary transaction id
  const generateTransactionId = () => {
    return `claya-order-${Date.now()}`
  }
  
  const everflowConversion = () => {
    // For now return as not needed on upsell load
    const script = document.createElement("script");
    const eFconversionCodeExecuted = window.localStorage.getItem(
      "EFconversionCodeExecuted"
    );
    script.src = "https://www.sffpl8trk.com/scripts/sdk/everflow.js";
    script.type = "text/javascript";
    script.async = true;
    script.onload = () => {
      const price = parseInt(localStorage.getItem("planPrice") || "");
      if (window.EF && eFconversionCodeExecuted !== "true") {
        window.EF.conversion({
          offer_id: parseInt(localStorage.getItem("offer_id") || "1"),
          affiliate_id: localStorage.getItem("affiliate_id") || "",
          amount: localStorage.getItem("planPrice") ? price : undefined,
        });
        window.localStorage.setItem("EFconversionCodeExecuted", "true");
        window.fbq("track", "Purchase", { currency: "USD", value: price });
      } else {
        console.warn("Everflow SDK failed to load.");
      }
    };
    document.body.appendChild(script);
  };
  
  const pushPurchaseEvent = (
    itemName: string,
    medicationType: string,
    price: string,
    planSelected: string,
    transactionID: string,
  ) => {
    if (localStorage.getItem("GTMPurchaseEventFired")) {
      return;
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: transactionID,
          value: price,
          currency: "USD",
          items: [
            {
              item_name: `${itemName}-${medicationType}`,
              price: price,
              quantity: 1,
              plan_selected: planSelected,
            },
          ],
        },
      });
      localStorage.setItem("GTMPurchaseEventFired", "true")
    }
  };

  useEffect(() => {
    const step14Completed = localStorage.getItem("step-14-completed");
    if (step14Completed) {
      safeNavigate("/getting-started/step-15");
    } else {
      safeNavigate("/getting-started/step-14");
    }
  }, []);


  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://fast.vidalytics.com/embeds/UDc5frbK/gVF2cMtfCuOh23Ip/loader.min.js";
    script.async = true;
    script.onload = () => {
      const vidalyticsScript = document.createElement("script");
      vidalyticsScript.innerHTML = `
        (function (v, i, d, a, l, y, t, c, s) {
          y='_'+d.toLowerCase(); c=d+'L'; if(!v[d]){v[d]={};} if(!v[c]){v[c]={};} if(!v[y]){v[y]={};}
          var vl='Loader', vli=v[y][vl], vsl=v[c][vl + 'Script'], vlf=v[c][vl + 'Loaded'], ve='Embed';
          if (!vsl){ vsl=function(u,cb){
            if(t){cb();return;} s=i.createElement("script"); s.type="text/javascript"; s.async=1; s.src=u;
            if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}
            i.getElementsByTagName("head")[0].appendChild(s);
          }; }
          vsl(l+'loader.min.js',function(){if(!vli){var vlc=v[c][vl]; vli=new vlc();} vli.loadScript(l+'player.min.js',function(){var vec=v[d][ve]; t=new vec(); t.run(a); });});
        })(window, document, 'Vidalytics', 'vidalytics_embed_gVF2cMtfCuOh23Ip', 'https://fast.vidalytics.com/embeds/UDc5frbK/gVF2cMtfCuOh23Ip/');
      `;
      document.body.appendChild(vidalyticsScript);
    };

    document.body.appendChild(script);
    everflowConversion();
  }, []);

  const URL =
    process.env.REACT_APP_ENV === "production"
      ? "https://claya-ruby-b715fff96163.herokuapp.com"
      : "https://claya-stage-ruby-03e61b6e8c6b.herokuapp.com";

  const isProd = process.env.REACT_APP_ENV === "production";
  let additionalPriceId = "";
  if (isProd) {
    additionalPriceId = "price_1QsGObGejApNyv7XyX7uqWEo";
  } else {
    additionalPriceId = "price_1Qmi68GejApNyv7XLjdlvE7D";
  }
  const callDummyApi = async () => {
    const isSupplementAdded = "Yes"
    try {
      setIsLoading1(true);
      const email = JSON.parse(localStorage.getItem("email") || "{}").value;
      const response = await fetch(
        `${URL}/api/v1/patients/payments/update_and_capture_subscription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customer_id,
            base_price_id,
            product_name: `${itemName.toLowerCase()}-${medicationType.toLowerCase()}`,
            planType,
            email,
            additional_price_id: additionalPriceId,
            promo_code: promoCode,
            is_supplement_added: isSupplementAdded,
            uuid: uuidValue
          }),
        }
      );

      // Parse the response body
      const responseData = await response.json();

      if (!response.ok) {
        console.error("API Error:", responseData);
        setErr(responseData?.error);
        throw new Error(
          `Network error: ${response.status} - ${
            responseData?.error || "Unknown error"
          }`
        );
      } else {
        let transactionID = responseData['transaction_id'];
        pushPurchaseEvent(itemName, medicationType, planPrice, planType, transactionID);
        localStorage.setItem(
          "success_transaction",
          JSON.stringify({ key: "success_transaction", value: responseData["success"] })
        );
        safeNavigate("/getting-started/step-16");
        localStorage.setItem('promoCode',"");
        localStorage.setItem("lastVisitedPage", "/getting-started/step-16");
        localStorage.setItem("step-15-completed", "true");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading1(false);
    }
  };

  let finalAmount = 100;

  const callDummyApi2 = async () => {
    const isSupplementAdded = "No"
    try {
      setIsLoading2(true);
      const email = JSON.parse(localStorage.getItem("email") || "{}").value;
      const response = await fetch(
        `${URL}/api/v1/patients/payments/update_and_capture_subscription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customer_id,
            base_price_id,
            email,
            product_name: `${itemName.toLowerCase()}-${medicationType.toLowerCase()}`,
            planType,
            promo_code: promoCode,
            is_supplement_added: isSupplementAdded,
            uuid: uuidValue
          }),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        console.error("API Error:", data);
        setErr(data?.error);
        throw new Error(
          `Network error: ${response.status} - ${
            data?.error || "Unknown error"
          }`
        );
      } else {
        let transactionID = data['transaction_id'];
        pushPurchaseEvent(itemName, medicationType, planPrice, planType, transactionID);
        localStorage.setItem(
          "success_transaction",
          JSON.stringify({ key: "success_transaction", value: data["success"] })
        );
        safeNavigate("/getting-started/step-16");
        localStorage.setItem("lastVisitedPage", "/getting-started/step-16");
        localStorage.setItem("step-15-completed", "true");
        localStorage.setItem('promoCode',"")
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading2(false);
    }
  };

  const ProductPoint = ({
    title,
    description,
  }: {
    title: string;
    description: string;
  }) => (
    <div className="post-checkout-product-points">
      <img src={CheckedMark} alt="checked_mark" />
      <div className="product-point">
        <p>{title} </p>
        <span>{description}</span>{" "}
      </div>
    </div>
  );

  const PostCheckoutProductDetails = () => {
    const productPoints = [
      {
        title: "Balance",
        description: "Essential magnesium for energy and calm.",
      },
      { title: "Sync", description: "Improves metabolism and fat regulation" },
      {
        title: "Nourish ",
        description: "Pure plant-powered protein for muscle maintenance",
      },
      {
        title: "Renew ",
        description: "Advanced antioxidant support during rapid weight loss",
      },
    ];

    return (
      <div className="post-checkout-product-details">
        {productPoints.map((point, index) => (
          <ProductPoint
            key={index}
            title={point.title}
            description={point.description}
          />
        ))}
      </div>
    );
  };

  return (
    <PageWrapper>
      <div className="signup-page-container page-upsell-container">
        <p
          className="addtional-product-heading1"
          style={{ textAlign: "center" }}
        >
          <span className="wait" style={{ color: "#894395" }}>
            Wait...
          </span>{" "}
          Your Order Is Not Yet Complete!
          <br />
          <span className="addtional-product-heading2">
            Do not hit the “Back” button as it may cause multiple charges on
            your card.
          </span>
        </p>
        <div className="post-checkout-content">
          <div className="post-checkout-product">
            <img src={EmpoweredBundle} alt="empowered_bundle" />
            <div>
              <h1 className="post-checkout-product-title">
                Empowered Foundation <br /> Bundle
              </h1>
              <p className="post-checkout-product-sub-heading">
                Maximize the benefits of GLP-1, and feel your absolute best
                every step of the way
              </p>
              <div className="post-checkout-product-price">
                <p className="product-actual-price">$347</p>
                <p className="product-offer-price">$147</p>
                <p>
                  <span className="product-offer-label">60% OFF</span>
                </p>
              </div>
              <PostCheckoutProductDetails />
            </div>
          </div>
          <div className="post-checkout-button">
            <button
              className="post-checkout-next-btn"
              onClick={callDummyApi}
              disabled={isLoading1 || isLoading2}
              style={{
                backgroundColor: (isLoading1||isLoading2) ? "#d3d3d3" : "#0c3972",
                cursor: isLoading1 ? "not-allowed" : "pointer",
              }}
            >
              {isLoading1 || isLoading2
                ? "Processing"
                : "YES! add Bundle for only $147"}
            </button>
            <p
              className="post-checkout-no-thanks-link"
              onClick={callDummyApi2}
              style={{
                cursor: isLoading2 ? "not-allowed" : "pointer",
                display: isLoading1 || isLoading2 ? "none" : "",
              }}
            >
              No, thanks. Please continue with only my GLP-1 order without these
              helpful supplements.
            </p>
          </div>
          <div>
            {err && <p className="post-checkout-error-message">{err}</p>}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage26;
